import {
  addListener,
  createListenerMiddleware,
  type TypedAddListener,
  type TypedStartListening,
} from "@reduxjs/toolkit";

import { isInIframe } from "@/base/utils/iframeUtils";

import { addContactInfoListeneres } from "./contactInfo/listeners";
import { addPaymentListeners } from "./payment/listeners";
import { addOrdersListeneres } from "./orders";
import { addProductsListeners } from "./products";
import { addShoppingCartListeneres } from "./shoppingCart";
import type { RootState } from "./slices";
import type { AppDispatch } from "./store";
import { addTheatreResourceListeneres } from "./theatreResource";
import { addUserListeneres } from "./user";

export const listenerMiddleware = createListenerMiddleware();

export type AppStartListening = TypedStartListening<RootState, AppDispatch>;

export const startAppListening =
  listenerMiddleware.startListening as AppStartListening;

export const addAppListener = addListener as TypedAddListener<
  RootState,
  AppDispatch
>;

export default listenerMiddleware.middleware;

if (!isInIframe()) {
  addUserListeneres(startAppListening);
  addShoppingCartListeneres(startAppListening);
  addContactInfoListeneres(startAppListening);
  addTheatreResourceListeneres(startAppListening);
  addOrdersListeneres(startAppListening);
  addPaymentListeners(startAppListening);
  addProductsListeners(startAppListening);
}
